import React, { Component } from 'react';

import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import LeadsListContainer from '../LeadsList/LeadsListContainer';


class LeadsListFiltered extends Component{
  render() {

    const {data: {loading, leads, refetch}, app_data, filter_data} = this.props;

    if(loading) {
      return (<div>Загрузка</div>);
    }


    const added_count = leads.reduce((count, lead) => {

      if(lead.remonline_id) {
        count++;
      }

      return count;

    }, 0);

    return (

      <div>
        <div className="leads_list__count">
          <span className="leads_list__count__label">Количество:</span>
          <span className="leads_list__count__number"> {leads.length} </span>
          <br/>
          <span className="leads_list__count__label">Принято:</span>
          <span className="leads_list__count__number"> {added_count}</span>
        </div>

        <LeadsListContainer leads={leads} app_data={app_data} filter_data={filter_data} refetch={refetch} with_client={true}/>
      </div>

    );
  }
}


export default compose(

  graphql(gql`query leads(
      $start_date: String!,
      $end_date: String!,
      $device_type_id: ID!,
      $problem_type_id: ID!,
      $status_id: ID!,
      $model: String!,
      $phone: String!,
      $act_number: String!,
    ){
    leads(start_date: $start_date, end_date: $end_date, device_type_id: $device_type_id, problem_type_id: $problem_type_id, status_id: $status_id, model: $model, phone: $phone, act_number: $act_number){
      id,
      remonline_data,
      remonline_id,
      act_number,
      device_type_id,
      problem_type_id,
      status_id,
      model,
      comment,
      created_at,
      first_call_by_id,
      created_by_id,
      confirmed_by_id,
      client {
        id,
        name,
        phone
      }
    }
  }`, {
    options: ({filter_data: {
      start_date,
      end_date,
      device_type_id,
      problem_type_id,
      status_id,
      model,
      phone,
      act_number,
    }}) => {

      return {
        variables: {
          start_date: start_date.toDate(),
          end_date: end_date.toDate(),
          device_type_id,
          problem_type_id,
          status_id,
          model,
          phone,
          act_number,
        }
      }

    }
  }),


)(LeadsListFiltered);